import React, { Suspense } from "react";
import { BrowserRouter, Routes, Route, Outlet } from "react-router-dom";
// import login Route
import Login from "../Pages/Login";
// login page child routes
import Loginpage from "../Containers/Loginpages/Loginpage/Loginpage";
import Otppage from "../Containers/Loginpages/Otppage/Otppage";
import Verificationpage from "../Containers/Loginpages/Verificationpage/Verificationpage";
import Resetpass from "../Containers/Loginpages/Resetpassword/Resetpass";
import Emailverifycode from "../Containers/Loginpages/Emailverifycode/Emailverifycode";
import Createnewpassword from "../Containers/Loginpages/Createnewpassword/Createnewpassword";
import Splashpage from "../Containers/Loginpages/Splashpage/Splashpage";
import Home from "../Pages/Home";
import Product from "../Containers/Coupons/Product";
import PrivateRoute from "./PrivateRoute";
import PublicRoute from "./PublicRoute";
import SettingsLayout from "../Pages/Settings";
import Settings from "../Containers/Settings";
import RoutingSchedule from "../Containers/Settings/RoutingSchedule";

// import layout with lazy loading
const Layout = React.lazy(() => import("../Components/Layout/Layout"));
// import home pages child routes with lazy loading
const Dashboard = React.lazy(() =>
  import("../Containers/Homepages/Dashboard/Dashboard")
);
const Profilepage = React.lazy(() =>
  import("../Containers/Homepages/Profilepage/Profilepage")
);
const Workingdriverspage = React.lazy(() =>
  import("../Containers/Homepages/Workingdriverspage/Workingdriverspage")
);
const Openstores = React.lazy(() =>
  import("../Containers/Homepages/Openstores/Openstores")
);
const Overloadedstores = React.lazy(() =>
  import("../Containers/Homepages/Overloadedstores/Overloadedstores")
);
const Overloadedregions = React.lazy(() =>
  import("../Containers/Homepages/Overloadedregions/Overloadedregions")
);
const Dueorders = React.lazy(() =>
  import("../Containers/Homepages/Dueorders/Dueorders")
);
const Answeredcalls = React.lazy(() =>
  import("../Containers/Homepages/Answeredcalls/Answeredcalls")
);
const CallerDetails = React.lazy(() =>
  import("../Containers/Homepages/Answeredcalls/Callerdetails/CallerDetails")
);

// import databases child routes
const Databases = React.lazy(() => import("../Pages/Databases"));
// importing child routes of databases
const Customers = React.lazy(() =>
  import("../Containers/Databasepage/Customers/Customers")
);
// depth 1 child routes
const Customerprofile = React.lazy(() =>
  import("../Containers/Databasepage/Customers/Customerprofile/Customerprofile")
);
// depth 2 child routes
const Cprofile = React.lazy(() => import("../Components/Cprofile/Cprofile"));
const Corders = React.lazy(() => import("../Components/Corders/Corders"));
const Ctransactions = React.lazy(() =>
  import("../Components/Ctransactions/Ctransactions")
);
const Corderfullview = React.lazy(() =>
  import("../Components/Corderfullview/Corderfullview")
);
const Corderedit = React.lazy(() =>
  import("../Components/Corderedit/Corderedit")
);
// end of database customers route

// database drivers routes start
const Drivers = React.lazy(() =>
  import("../Containers/Databasepage/Drivers/Drivers")
);
const DriversDatabase = React.lazy(() =>
  import("../Containers/Databasepage/Drivers/DriversDatabase/DriversDatabase")
);
// driver dynamic route
const DriverDynamicRoute = React.lazy(() =>
  import(
    "../Containers/Databasepage/Drivers/DriverDynamicRoute/DriverDynamicRoute"
  )
);
// driver profile
const DriverProfile = React.lazy(() =>
  import("../Containers/Databasepage/Drivers/DriverProfile/DriverProfile")
);
const EditDriverProfile = React.lazy(() =>
  import(
    "../Containers/Databasepage/Drivers/EditDriverProfile/EditDriverProfile"
  )
);

const DriverOrders = React.lazy(() =>
  import("../Containers/Databasepage/Drivers/DriversOrders/DriversOrders")
);

const EditDriverOrder = React.lazy(() =>
  import("../Containers/Databasepage/Drivers/EditDriverOrder/EditDriverOrder")
);

// const EditDriverOrder = React.lazy(() =>
//   import("./Containers/Databasepage/Drivers/EditDriverOrder/EditDriverOrder")
// );
const DriversTransactions = React.lazy(() =>
  import(
    "../Containers/Databasepage/Drivers/DriversTransactions/DriversTransactions"
  )
);

const DriverSchedule = React.lazy(() =>
  import("../Containers/Databasepage/Drivers/DriverSchedule/DriverSchedule")
);

const Sellers = React.lazy(() =>
  import("../Containers/Databasepage/Sellers/Sellers")
);
// database sellers routes start
const SellersDatabase = React.lazy(() =>
  import("../Containers/Databasepage/Sellers/SellersDatabase/SellersDatabase")
);
// seller dynamic route
const SellerDynamicRoute = React.lazy(() =>
  import(
    "../Containers/Databasepage/Sellers/SellerDynamicRoute/SellerDynamicRoute"
  )
);
// seller profile
const SellerProfile = React.lazy(() =>
  import("../Containers/Databasepage/Sellers/SellerProfile/SellerProfile")
);
const SellerEditProfile = React.lazy(() =>
  import(
    "../Containers/Databasepage/Sellers/SellerProfile/SellerEditProfile/SellerEditProfile"
  )
);
// seller product page
const SellersProducts = React.lazy(() =>
  import("../Containers/Databasepage/Sellers/SellersProducts/SellersProducts")
);
const SellerProductsFolder = React.lazy(() =>
  import(
    "../Containers/Databasepage/Sellers/SellersProducts/SellerProductsFolder/SellerProductsFolder"
  )
);
const SellerCreateNewItem = React.lazy(() =>
  import(
    "../Containers/Databasepage/Sellers/SellersProducts/SellerCreateNewItem/SellerCreateNewItem"
  )
);

const SellersOrders = React.lazy(() =>
  import("../Containers/Databasepage/Sellers/SellersOrders/SellersOrders")
);
const SellersTransactions = React.lazy(() =>
  import(
    "../Containers/Databasepage/Sellers/SellersTransactions/SellersTransactions"
  )
);
const SellerLedger = React.lazy(() =>
  import("../Containers/Databasepage/Sellers/SellerLedger/SellerLedger")
);
// seller ledger child routes
const SellerLedgerindex = React.lazy(() =>
  import(
    "../Containers/Databasepage/Sellers/SellerLedger/SellerLedgerindex/SellerLedgerindex"
  )
);
const LedgerDetails = React.lazy(() =>
  import(
    "../Containers/Databasepage/Sellers/SellerLedger/LedgerDetails/LedgerDetails"
  )
);
const LedgerTranactionsView = React.lazy(() =>
  import(
    "../Containers/Databasepage/Sellers/SellerLedger/LedgerTransactionsView/LedgerTranactionsView"
  )
);
const SellerPromotion = React.lazy(() =>
  import("../Containers/Databasepage/Sellers/SellerPromotion/SellerPromotion")
);

// Orders
const Orders = React.lazy(() =>
  import("../Containers/Databasepage/Orders/Orders")
);
const AllOrders = React.lazy(() =>
  import("../Containers/Databasepage/Orders/AllOrders/AllOrders")
);
// sellers dynamic routes end

// Coupons Starts
const Coupons = React.lazy(() => import("../Pages/Coupons"));
const AllCoupons = React.lazy(() => import("../Containers/Coupons"));
const ReNewCoupon = React.lazy(() =>
  import("../Containers/Coupons/NewCouponCard/NewCouponCard")
);

// Coupons Ends

// import inquiries pages
const Inquiries = React.lazy(() => import("../Pages/Inquiries"));
// child routes
const AllInquiries = React.lazy(() => import("../Containers/Inquiriespages"));
const InquiriesRequests = React.lazy(() =>
  import("../Containers/Inquiriespages/InquiriesRequests")
);
const InquiriesBusinesses = React.lazy(() =>
  import("../Containers/Inquiriespages/InquiriesRequests/Business")
);
// const BusinessStartingRequest = React.lazy(() =>
//   import("../Containers/Inquiriespages/InquiriesRequests/Business/index")
// );

const BusinessStartingView = React.lazy(() =>
  import(
    "../Containers/Inquiriespages/InquiriesRequests/Business/BusinessStartingView"
  )
);
const InquiriesListings = React.lazy(() =>
  import("../Containers/Inquiriespages/InquiriesRequests/Listings")
);
const ListingsStartingView = React.lazy(() =>
  import(
    "../Containers/Inquiriespages/InquiriesRequests/Listings/ListingsStartingView"
  )
);
// const Modalboxinquirie = React.lazy(() =>
//   import("../Containers/Inquiriespages/Modalbox/Modalboxinquirie")
// );
// import catagories pages
const Catagoeries = React.lazy(() => import("../Pages/Catagoeries"));
// child routes
const AllCatagoeries = React.lazy(() =>
  import("../Containers/Catagoeriespages")
);
const AddNewCategory = React.lazy(() =>
  import("../Containers/Catagoeriespages/AddNewCategory/AddNewCategory")
);
const SubCatagroiesProfile = React.lazy(() =>
  import(
    "../Containers/Catagoeriespages/SubcatagroiesProfile/SubCatagroiesProfile"
  )
);
//import templates pages
const Template = React.lazy(() => import("../Pages/Template"));
// child routes
const AllTemplates = React.lazy(() => import("../Containers/TemplatesPages"));
const ShowTemplate = React.lazy(() =>
  import("../Containers/TemplatesPages/components/ShowTemplate")
);
const CreateItem = React.lazy(() =>
  import("../Containers/TemplatesPages/components/listingIndex")
);
// image Library routes start
const ImageLibrary = React.lazy(() => import("../Pages/ImageLibrary"));
// // child routes
const AllimageLibrary = React.lazy(() =>
  import("../Containers/ImageLibrary/Index")
);
// image library routes end

// Banners Route Start
const BannersMain = React.lazy(() => import("../Pages/Banners"));
// // child routes
const Banners = React.lazy(() => import("../Containers/Banners/index"));
// Banners Route End

function Approutes() {
  return (
    <BrowserRouter>
      <Routes>
        <Route
          path="/"
          element={<PublicRoute Component={Login} restricted={true} />}
        >
          {/* child routes start */}
          <Route
            index
            element={<PublicRoute Component={Loginpage} restricted={true} />}
          />
          <Route
            path="otp"
            element={<PublicRoute Component={Otppage} restricted={true} />}
          />
          <Route
            path="verification"
            element={
              <PublicRoute Component={Verificationpage} restricted={true} />
            }
          />
          <Route
            path="resetpassword"
            element={<PublicRoute Component={Resetpass} restricted={true} />}
          />
          <Route
            path="emailverifycode"
            element={
              <PublicRoute Component={Emailverifycode} restricted={true} />
            }
          />
          <Route
            path="createnewpassword"
            element={
              <PublicRoute Component={Createnewpassword} restricted={true} />
            }
          />
          <Route
            path="splash"
            element={<PublicRoute Component={Splashpage} restricted={true} />}
          />
          <Route
            path="/product"
            element={<PublicRoute Component={Product} restricted={true} />}
          />
          {/* child routes end */}
        </Route>
        {/* authorization routes end */}
        {/* home routes start  */}
        <Route
          path="/dashboard"
          element={
            <Suspense fallback={<div>Loading...</div>}>
              <Layout children={<Home />} />
            </Suspense>
          }
        >
          {/* child routes start  */}
          <Route
            index
            element={
              <Suspense fallback={<div>Loading...</div>}>
                <PrivateRoute Component={Dashboard} />
              </Suspense>
            }
          />
          <Route
            path="profile"
            element={
              <Suspense fallback={<div>Loading...</div>}>
                <Profilepage />
              </Suspense>
            }
          />
          <Route
            path="workingdrivers"
            element={
              <Suspense fallback={<div>Loading...</div>}>
                <Workingdriverspage />
              </Suspense>
            }
          />
          <Route
            path="openstores"
            element={
              <Suspense fallback={<div>Loading...</div>}>
                <Openstores />
              </Suspense>
            }
          />
          <Route
            path="overloadedstores"
            element={
              <Suspense fallback={<div>Loading...</div>}>
                <Overloadedstores />
              </Suspense>
            }
          />
          <Route
            path="overloadedregions"
            element={
              <Suspense fallback={<div>Loading...</div>}>
                <Overloadedregions />
              </Suspense>
            }
          />
          <Route
            path="dueorders"
            element={
              <Suspense fallback={<div>Loading...</div>}>
                <Dueorders />
              </Suspense>
            }
          />
          <Route
            path="answeredcalls"
            element={
              <Suspense fallback={<div>Loading...</div>}>
                <Answeredcalls />
              </Suspense>
            }
          >
            <Route
              path=":callerId"
              element={
                <Suspense fallback={<div>Loading...</div>}>
                  <CallerDetails />
                </Suspense>
              }
            />
          </Route>
          {/* child routes end  */}
        </Route>
        {/* home routes end  */}
        {/* databases routes start */}
        <Route
          path="/databases"
          element={
            <Suspense fallback={<div>Loading...</div>}>
              <Layout children={<Databases />} />
            </Suspense>
          }
        >
          {/* child routes start  */}
          <Route
            index
            element={
              <Suspense fallback={<div>Loading...</div>}>
                <Customers />
              </Suspense>
            }
          />
          <Route
            path=":customerprofileid"
            element={
              <Suspense fallback={<div>Loading...</div>}>
                <Customerprofile />
              </Suspense>
            }
          >
            <Route
              index
              element={
                <Suspense fallback={<div>Loading...</div>}>
                  <Cprofile />
                </Suspense>
              }
            />
            <Route
              path="orders"
              element={
                <Suspense fallback={<div>Loading...</div>}>
                  <Corders />
                </Suspense>
              }
            />
            <Route
              path="ctransactions"
              element={
                <Suspense fallback={<div>Loading...</div>}>
                  <Ctransactions />
                </Suspense>
              }
            />
            <Route
              path="corderdetails"
              element={
                <Suspense fallback={<div>Loading...</div>}>
                  <Corderfullview />
                </Suspense>
              }
            />
            <Route
              path="editorder"
              element={
                <Suspense fallback={<div>Loading...</div>}>
                  <Corderedit />
                </Suspense>
              }
            />
          </Route>
          {/* sellers route start  */}
          <Route
            path="sellers"
            element={
              <Suspense fallback={<div>Loading...</div>}>
                <Sellers />
              </Suspense>
            }
          >
            <Route
              index
              element={
                <Suspense fallback={<div>Loading...</div>}>
                  <SellersDatabase />
                </Suspense>
              }
            />
            <Route
              path=":sellerid"
              element={
                <Suspense fallback={<div>Loading...</div>}>
                  <SellerDynamicRoute />
                </Suspense>
              }
            >
              <Route
                index
                element={
                  <Suspense fallback={<div>Loading...</div>}>
                    <SellerProfile />
                  </Suspense>
                }
              />
              <Route
                path="edit-profile"
                element={
                  <Suspense fallback={<div>Loading...</div>}>
                    <SellerEditProfile />
                  </Suspense>
                }
              />
              <Route
                path="products"
                element={
                  <Suspense fallback={<div>Loading...</div>}>
                    <SellersProducts />
                  </Suspense>
                }
              />
              <Route
                path="products/:productid"
                element={
                  <Suspense fallback={<div>Loading...</div>}>
                    <Outlet />
                  </Suspense>
                }
              >
                <Route
                  index
                  element={
                    <Suspense fallback={<div>Loading...</div>}>
                      <SellerProductsFolder />
                    </Suspense>
                  }
                />
                <Route
                  path="createnewitem"
                  element={
                    <Suspense fallback={<div>Loading...</div>}>
                      <SellerCreateNewItem />
                    </Suspense>
                  }
                />
              </Route>

              <Route
                path="orders"
                element={
                  <Suspense fallback={<div>Loading...</div>}>
                    <SellersOrders />
                  </Suspense>
                }
              />
              <Route
                path="corderdetails"
                element={
                  <Suspense fallback={<div>Loading...</div>}>
                    <Corderfullview />
                  </Suspense>
                }
              />
              <Route
                path="editorder"
                element={
                  <Suspense fallback={<div>Loading...</div>}>
                    <Corderedit />
                  </Suspense>
                }
              />
              <Route
                path="transactions"
                element={
                  <Suspense fallback={<div>Loading...</div>}>
                    <SellersTransactions />
                  </Suspense>
                }
              />
              <Route
                path="ledger"
                element={
                  <Suspense fallback={<div>Loading...</div>}>
                    <SellerLedger />
                  </Suspense>
                }
              >
                <Route
                  index
                  element={
                    <Suspense fallback={<div>Loading...</div>}>
                      <SellerLedgerindex />
                    </Suspense>
                  }
                />
                <Route
                  path="ledgerdetails"
                  element={
                    <Suspense fallback={<div>Loading...</div>}>
                      <LedgerDetails />
                    </Suspense>
                  }
                />
              </Route>
              <Route
                path="ledgertranactionsview"
                element={
                  <Suspense fallback={<div>Loading...</div>}>
                    <LedgerTranactionsView />
                  </Suspense>
                }
              />
              <Route
                path="promotion"
                element={
                  <Suspense fallback={<div>Loading...</div>}>
                    <SellerPromotion />
                  </Suspense>
                }
              />
            </Route>
          </Route>
          {/* sellers route end  */}
          {/* drivers routes start here */}
          <Route
            path="drivers"
            element={
              <Suspense fallback={<div>Loading...</div>}>
                <Drivers />
              </Suspense>
            }
          >
            <Route
              index
              element={
                <Suspense fallback={<div>Loading...</div>}>
                  <DriversDatabase />
                </Suspense>
              }
            />
            <Route
              path=":driverid"
              element={
                <Suspense fallback={<div>Loading...</div>}>
                  <DriverDynamicRoute />
                </Suspense>
              }
            >
              <Route
                index
                element={
                  <Suspense fallback={<div>Loading...</div>}>
                    <DriverProfile />
                  </Suspense>
                }
              />
              <Route
                path="orders"
                element={
                  <Suspense fallback={<div>Loading...</div>}>
                    <DriverOrders />
                  </Suspense>
                }
              />
              <Route
                path="edit-profile"
                element={
                  <Suspense fallback={<div>Loading...</div>}>
                    <EditDriverProfile />
                  </Suspense>
                }
              />
              <Route
                path="edit-order/:order_id"
                element={
                  <Suspense fallback={<div>Loading...</div>}>
                    <EditDriverOrder />
                  </Suspense>
                }
              />
              <Route
                path="transactions"
                element={
                  <Suspense fallback={<div>Loading...</div>}>
                    <DriversTransactions />
                  </Suspense>
                }
              />
              <Route
                path="schedules"
                element={
                  <Suspense fallback={<div>Loading...</div>}>
                    <DriverSchedule />
                  </Suspense>
                }
              />
            </Route>
          </Route>
          {/* drivers routes end here */}

          {/* Orders Route Start */}

          <Route
            path="orders"
            element={
              <Suspense fallback={<div>Loading...</div>}>
                <Orders />
              </Suspense>
            }
          >
            <Route
              index
              element={
                <Suspense fallback={<div>Loading...</div>}>
                  <AllOrders />
                </Suspense>
              }
            />
            <Route
              path="view/:order_id"
              element={
                <Suspense fallback={<div>Loading...</div>}>
                  <Corderfullview />
                </Suspense>
              }
            />
          </Route>

          {/* Order Routes End */}

          {/* child routes end  */}
        </Route>
        {/* databases routes end */}

        {/* Coupons Routes Start */}
        <Route
          path="/coupons"
          element={
            <Suspense fallback={<div>Loading...</div>}>
              <Layout children={<Coupons />} />
            </Suspense>
          }
        >
          <Route
            index
            path=""
            element={
              <Suspense fallback={<div>Loading...</div>}>
                <AllCoupons />
              </Suspense>
            }
          />
          <Route
            path="re-new-coupon"
            element={
              <Suspense fallback={<div>Loading...</div>}>
                <ReNewCoupon />
              </Suspense>
            }
          />
        </Route>
        {/* Coupons Routes End */}

        {/* inquiries routes start  */}
        <Route
          path="/inquiries"
          element={
            <Suspense fallback={<div>Loading...</div>}>
              <Layout children={<Inquiries />} />
            </Suspense>
          }
        >
          {/* <Route index
            element={
              <Suspense fallback={<div>Loading...</div>}>
                <Modalboxinquirie />
              </Suspense>
            }
          /> */}
          <Route
            index
            element={
              <Suspense fallback={<div>Loading...</div>}>
                <AllInquiries />
              </Suspense>
            }
          />
          <Route
            path="requests"
            element={
              <Suspense fallback={<div>Loading...</div>}>
                <InquiriesRequests />
              </Suspense>
            }
          />

          <Route
            path="businesses"
            element={
              <Suspense fallback={<div>Loading...</div>}>
                <InquiriesBusinesses />
              </Suspense>
            }
          />
          {/* <Route
            path="business-starting"
            element={
              <Suspense fallback={<div>Loading...</div>}>
                <BusinessStartingRequest />
              </Suspense>
            }
          /> */}
          <Route
            path="business-view"
            element={
              <Suspense fallback={<div>Loading...</div>}>
                <BusinessStartingView />
              </Suspense>
            }
          />

          <Route
            path="listings"
            element={
              <Suspense fallback={<div>Loading...</div>}>
                <InquiriesListings />
              </Suspense>
            }
          />
          <Route
            path="listings-view"
            element={
              <Suspense fallback={<div>Loading...</div>}>
                <ListingsStartingView />
              </Suspense>
            }
          />
        </Route>
        {/* inquiries routes end */}

        {/* categories routes start  */}
        <Route
          path="/categories"
          element={
            <Suspense fallback={<div>Loading...</div>}>
              <Layout children={<Catagoeries />} />
            </Suspense>
          }
        >
          {/* <Route
            index
            element={
              <Suspense fallback={<div>Loading...</div>}>
                <Modalboxinquirie />
              </Suspense>
            }
          /> */}
          <Route
            index
            element={
              <Suspense fallback={<div>Loading...</div>}>
                <AllCatagoeries />
              </Suspense>
            }
          />
          <Route
            path="SubCatagroiesProfile"
            element={
              <Suspense fallback={<div>Loading...</div>}>
                <SubCatagroiesProfile />
              </Suspense>
            }
          />

          {/* Saad changes */}
          <Route
            path="new"
            element={
              <Suspense fallback={<div>Loading...</div>}>
                <AddNewCategory />
              </Suspense>
            }
          />
          <Route
            path="/categories/SubCatagroiesProfile/new"
            element={
              <Suspense fallback={<div>Loading...</div>}>
                <AddNewCategory />
              </Suspense>
            }
          />
        </Route>
        {/* categories routes end */}

        {/* Templates routes start  */}
        <Route
          path="/create-templates"
          element={
            <Suspense fallback={<div>Loading...</div>}>
              <Layout children={<Template />} />
            </Suspense>
          }
        >
          <Route
            index
            element={
              <Suspense fallback={<div>Loading...</div>}>
                <AllTemplates />
              </Suspense>
            }
          />
          {/* <Route
            path="SubCatagroiesProfile"
            element={
              <Suspense fallback={<div>Loading...</div>}>
                <SubCatagroiesProfile />
              </Suspense>
            }
          /> */}

          <Route
            path="new"
            element={
              <Suspense fallback={<div>Loading...</div>}>
                <CreateItem />
              </Suspense>
            }
          />
          <Route
            path="show-templates"
            element={
              <Suspense fallback={<div>Loading...</div>}>
                <ShowTemplate />
              </Suspense>
            }
          />
        </Route>
        {/* Templates routes end */}

        {/*image library routes start  */}
        <Route
          path="/Image-library"
          element={
            <Suspense fallback={<div>Loading...</div>}>
              <Layout children={<ImageLibrary />} />
            </Suspense>
          }
        >
          <Route
            index
            element={
              <Suspense fallback={<div>Loading...</div>}>
                <AllimageLibrary />
              </Suspense>
            }
          />
        </Route>
        {/* image library rouotes end */}
        {/* Banners route start */}
        <Route
          path="/banners"
          element={
            <Suspense fallback={<div>Loading...</div>}>
              <Layout children={<BannersMain />} />
            </Suspense>
          }
        >
          <Route
            index
            element={
              <Suspense fallback={<div>Loading...</div>}>
                <Banners />
              </Suspense>
            }
          />
        </Route>
        {/* Banners Route end */}

        {/* Banners route start */}
        <Route
          path="/settings"
          element={
            <Suspense fallback={<div>Loading...</div>}>
              <Layout children={<SettingsLayout />} />
            </Suspense>
          }
        >
          <Route
            index
            element={
              <Suspense fallback={<div>Loading...</div>}>
                <Settings />
              </Suspense>
            }
          />
          <Route
            path="routing-schedule"
            element={
              <Suspense fallback={<div>Loading...</div>}>
                <RoutingSchedule />
              </Suspense>
            }
          />
        </Route>
        {/* Banners Route end */}
      </Routes>
    </BrowserRouter>
  );
}

export default Approutes;
